var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas",staticClass:"canvas",staticStyle:{"border":"1px solid red"},attrs:{"id":"canvas-box"}}),_c('van-button',{attrs:{"type":"info"},on:{"click":_vm.printTemplate}},[_vm._v("打印")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }